import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/404-ghost.png")